import React from 'react';
import co_curricular from '../../assests/img/co-curricular.jpg';

const CoCurricular = () => {

    return (
        <>
            <div className='inner_top_about_us'>
                <div id="bg" className="data-typography-1 data-theme-1">
                    <div className="page-wraper">
                        <div className="page-content bg-white">
                            <div className="dz-bnr-inr dz-bnr-inr-sm style-1 text-center overlay-primary-dark">
                                <div className="coustom_container">
                                    <div className="dz-bnr-inr-entry">
                                        <div className="pheading">
                                            <h1>Co-Curricular</h1>
                                        </div>
                                        <nav aria-label="breadcrumb" className="breadcrumb-row">
                                            <ul className="breadcrumb">
                                                <li className="breadcrumb-item">
                                                    <a href="/">Home</a>
                                                </li>
                                                <li className="mx-2">
                                                    /
                                                </li>
                                                <li className="breadcrumb-item active" aria-current="page">
                                                    Co-Curricular
                                                </li>
                                            </ul>
                                        </nav>
                                    </div>
                                </div>
                            </div>


                            <section className="content-inner section-wrapper5 pt-5 pb-5">
                                <div className="coustom_container">
                                    <div className="row">
                                        <div
                                            className="col-xl-9 col-lg-6 m-b30 wow fadeInUp"
                                            data-wow-delay="0.4s"
                                        >
                                            <div id="pagedata" className="pagedata">
                                                <p style={{ textAlign: "justify" }}>
                                                    <img src={co_curricular} alt="co-curricular" width="100%" />
                                                </p>
                                                <p style={{ textAlign: "justify" }}>
                                                    Beyond the curriculum, KCMS aims to provide a myriad of societies, clubs and activities, from chess, cookery, law, ornithology to space exploration. Pupils will be encouraged to join any in which they are interested and to explore new opportunities, regardless of previous experience.
                                                </p>
                                                <p style={{ textAlign: "justify" }}>
                                                    Our lunch break will be long, providing ample time to have a bite to eat and then rehearse a scene from a play, practise a movement of a dance number, complete a training session on the basketball court or cricket net, debate the nuances of uniform civil code, or listen to the memories of a veteran soldiers. Such exploration beyond the classroom enables students to relate what they learn in lessons to the world outside. All these and many more activities may take place during a lunchtime at KCMS. Yet such opportunities are not just restricted to the middle of the day; pupils may stay after school to rehearse, practise, study or train.
                                                </p>
                                                <p style={{ textAlign: "justify" }}>
                                                    An inter-house competition will be held throughout the year, with activities including sports, the arts, engineering and games, designed to accommodate pupils of all interests and abilities. The house system will enables our pupils to enjoy healthy competition whilst forming lasting bonds with those in different year groups. It’ll not only help them forge social bonds but will also help in developing future leaders.
                                                </p>
                                                <p style={{ textAlign: "justify" }}>
                                                    On many occasions during the school year, there will be those special one-off events and visits that are remembered well into the future. Exhibitions of pupils’ work, visits to galleries, field trips and team building expeditions, residential trips, guest speakers at assembly, and author talks – all these and more to enrich school life a little further for pupils at KCMS.
                                                </p>
                                            </div>
                                        </div>

                                        <div
                                            className="col-xl-3 col-lg-6 wow fadeInUp"
                                            data-wow-delay="0.2s"
                                        >
                                            <div className="bg-lgrey">
                                                <div className="subMenubg active">
                                                    <a href="spiritual-care-and-wellbeing" target="_self" className="submenu">
                                                        Spiritual care and Wellbeing
                                                    </a>
                                                </div>
                                                <div className="subMenubg">
                                                    <a
                                                        href="academic-life"
                                                        target="_self"
                                                        className="submenu"
                                                    >
                                                        Academic Life
                                                    </a>
                                                </div>
                                                <div className="subMenubg">
                                                    <a href="sporting-life" target="_self" className="submenu">
                                                        Sporting Life
                                                    </a>
                                                </div>
                                                <div className="subMenubg">
                                                    <a href="co-curricular" className="submenu">
                                                        Co-curricular
                                                    </a>
                                                </div>
                                                <div className="subMenubg">
                                                    <a href="social-responsibility" target="_self" className="submenu">
                                                        Social Responsibility
                                                    </a>
                                                </div>
                                                <div className="subMenubg">
                                                    <a
                                                        href="activities"
                                                        target="_self"
                                                        className="submenu"
                                                    >
                                                        Activities
                                                    </a>
                                                </div>
                                                <div className="subMenubg">
                                                    <a
                                                        href="amenities"
                                                        target="_self"
                                                        className="submenu"
                                                    >
                                                        Amenities
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>
                        </div>

                        <button className="scroltop icon-up" type="button">
                            <i className="fas fa-arrow-up"></i>
                        </button>
                    </div>
                </div>
            </div >
        </>
    )
}

export default CoCurricular;